export const navigationConfig = {
  mainNav: [
    {
      text: "Events",
      icon: "heroicons:calendar",
      to: "/events",
      type: "megamenu",
      items: [
        {
          title: "Browse By  Category",
          items: [
            {
              text: "All Events",
              to: "/events",
              icon: "heroicons:squares-2x2",
            },
            {
              text: "Health Sciences",
              to: "/events?categories=1",
              icon: "heroicons:heart",
            },
            {
              text: "Management",
              to: "/events?categories=2",
              icon: "heroicons:briefcase",
            },
            {
              text: "Engineering and Technology",
              to: "/events?categories=3",
              icon: "heroicons:cpu-chip",
            },
            {
              text: "Liberal Arts, Humanities & Social Sciences",
              to: "/events?categories=5",
              icon: "heroicons:academic-cap",
            },
          ],
        },

        {
          title: "Popular Tags",
          items: [
            {
              text: "Neurology and Neurosurgery",
              to: "/events?tags=18",
              icon: "heroicons:bolt",
            },
            {
              text: "Emergency Medicine",
              to: "/events?tags=40",
              icon: "heroicons:bolt",
            },
            {
              text: "Anesthesiology",
              to: "/events?tags=41",
              icon: "heroicons:bolt",
            },
            {
              text: "General Surgery",
              to: "/events?tags=17",
              icon: "heroicons:bolt",
            },
          ],
        },
        {
          title: "Browse By Event Types",
          items: [
            {
              text: "Conference",
              to: "/events?types=1",
              icon: "heroicons:user-group",
            },
            {
              text: "Certificate Courses and Fellowships",
              to: "/events?types=5",
              icon: "heroicons:academic-cap",
            },
            {
              text: "Symposium, Conclave, Seminar",
              to: "/events?types=6",
              icon: "heroicons:presentation-chart-bar",
            },
            {
              text: "Workshops and Training Programs",
              to: "/events?types=3",
              icon: "heroicons:wrench-screwdriver",
            },
          ],
        },
      ],
    },
    {
      text: "Community",
      icon: "heroicons:user-group",
      to: "/people",
      type: "dropdown",
      items: [
        { text: "Browse People", to: "/people", icon: "heroicons:users" },
        {
          text: "Become a member",
          to: "/become-a-member",
          icon: "heroicons:academic-cap",
        },
      ],
    },
    {
      text: "Buzz",
      icon: "heroicons:chat-bubble-left-right",
      to: "/buzz",
      type: "link",
    },
    {
      text: "More",
      icon: "heroicons:ellipsis-horizontal-circle",
      to: "/About",
      type: "dropdown",
      items: [
        { text: "Add Event", to: "/add", icon: "heroicons:plus-circle" },
        {
          text: "About Us",
          to: "/about/",
          icon: "heroicons:information-circle",
        },
        { text: "Contact", to: "/about/contact", icon: "heroicons:envelope" },
      ],
    },
  ],
  authNav: {
    guest: [
      {
        text: "Sign In",
        to: "/auth/signin",
        icon: "heroicons:arrow-right-on-rectangle",
        variant: "ghost",
      },
      {
        text: "Sign Up",
        to: "/auth/signup",
        icon: "heroicons:user-plus",
        variant: "primary",
      },
    ],
    user: [
      { text: "Dashboard", to: "/dashboard", icon: "heroicons:squares-2x2" },
      { text: "Settings", to: "/settings", icon: "heroicons:cog-6-tooth" },
      {
        text: "Sign Out",
        action: "signOut",
        icon: "heroicons:arrow-left-on-rectangle",
      },
    ],
  },
};
